import { watchFormFields } from '_forms.js';

// forEach polyfill
if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

const formTextInputs = document.querySelectorAll('.has-label-shift input[type="text"], .has-label-shift textarea');
const elementsToShow = document.querySelectorAll( '.animate, .js-circular-list' );
const header = document.getElementById('header');
const debug = false;

const scrollProps = {
	'scrollStatus' 					: null,
	'scrollPercentage' 			: null,
	'scrollDirection'				: null,
	'windowY'								: null,
	'lastKnownY'						: null,
	'directionReversedAt' 	: null,
	'distanceSinceReverse' 	: null,
	'compressesAt'					: 400,
	'unsticksAt'						: 500,
	'directionThreshold'		: 80
};

let scroll = window.requestAnimationFrame; // || function( callback ){ window.setTimeout( callback, 1000/60 ); }


const init = function() {

	if ( debug ) setupScrollDebugger();

	setTimeout( () => {
		document.body.classList.add( 'enable-header-transitions' )
	}, 250 );

	loop();

};


const setupScrollDebugger = function() {

	const debugPane = document.createElement('div');
	debugPane.style.fontSize = '12px';
	debugPane.style.lineHeight = '1.4';
	debugPane.style.padding = '1rem';
	debugPane.style.right = '0';
	debugPane.style.top = '10rem';
	debugPane.style.backgroundColor = '#ffffff';
	debugPane.style.zIndex = '999';
	debugPane.style.position = 'fixed';
	debugPane.style.borderRadius = '0';
	debugPane.style.boxShadow = '0 0 2rem rgba(0,0,0,0.2)';
	debugPane.style.width = '12rem';
	document.body.appendChild(debugPane);

	const labels = [
		[ 'Scroll Status', 'scrollStatus' ],
		[ 'Scroll Direction', 'scrollDirection' ],
		[ 'Scroll Percentage', 'scrollPercentage' ],
		[ 'Window Y Position', 'windowY' ],
		[ 'Last Known Y', 'lastKnownY' ],
		[ 'Reversed at', 'directionReversedAt' ],
		[ 'Since reverse' , 'distanceSinceReverse'],
		[ 'Direction threshold', 'directionThreshold' ],
		[ 'Unsticks at', 'unsticksAt' ]
	];

	labels.forEach( (row) => {

		const label = row[0];
		const id = row[1];
		const nodeWrap = document.createElement('div');
		const nodeLabel = document.createElement('strong');
		const nodeValue = document.createElement('span');

		nodeLabel.innerHTML = label;
		nodeValue.setAttribute('id',id);
		nodeValue.innerHTML = '0';
		nodeWrap.style.display = "flex";
		nodeWrap.style.justifyContent = "space-between";
	
		nodeWrap.appendChild(nodeLabel);
		nodeWrap.appendChild(nodeValue);
		debugPane.appendChild(nodeWrap);

	} );

	updateDebugger();

};


const updateDebugger = function() {

	document.getElementById('scrollStatus').innerHTML = scrollProps.scrollStatus;
	document.getElementById('lastKnownY').innerHTML = scrollProps.lastKnownY;
	document.getElementById('windowY').innerHTML = Math.round(scrollProps.windowY * 100) / 100;
	document.getElementById('scrollPercentage').innerHTML = Math.round(scrollProps.scrollPercentage * 100) / 100;
	document.getElementById('scrollDirection').innerHTML = scrollProps.scrollDirection;
	document.getElementById('directionReversedAt').innerHTML = scrollProps.directionReversedAt;
	document.getElementById('distanceSinceReverse').innerHTML = scrollProps.distanceSinceReverse;
	document.getElementById('directionThreshold').innerHTML = scrollProps.directionThreshold;
	document.getElementById('unsticksAt').innerHTML = scrollProps.unsticksAt;

}


const loop = function() {

	updateScrollProps();

	if ( debug ) {
		updateDebugger();
	}

	watchFormFields( formTextInputs );
	watchForAnimationItems();
	topWatch();

	scroll( loop );

};


const watchForAnimationItems = function() {

	elementsToShow.forEach( ( element ) => {
		
		const baseClass = 'animated';
		const children = element.querySelectorAll('.toAnimate')

		if ( isAnyPartOfElementInViewport( element ) ) {

			if ( element.classList.contains( baseClass ) ) {
				return;
			}

			element.classList.add( baseClass );

			if ( children ) {
				children.forEach( ( childElement ) => {
					childElement.classList.remove('toAnimate')
					childElement.classList.add('animate')
					childElement.classList.add('animated')
				} )				
			}
		
		}
	});

}


const updateScrollProps = function() {

	updateWindowY();

}


const updateWindowY = function() {

	const supportPageOffset = window.pageXOffset !== undefined;
	const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	const windowY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

	scrollProps.windowY = windowY;

}


const topWatch = function() {

	if ( !header ) return;

	const className = 'is-at-top';

	if ( scrollProps.windowY === 0 ) {
		document.body.classList.add( className );
	} else {
		document.body.classList.remove( className );
	}

}


/**
 * @ see https://gist.github.com/davidtheclark/5515733
 */
const isAnyPartOfElementInViewport = function( el ) {

	const offset			 = el.getAttribute('data-animation-offset') ? parseInt( el.getAttribute('data-animation-offset') ) : 0
	const rect 				 = el.getBoundingClientRect()
	const windowHeight = (window.innerHeight || document.documentElement.clientHeight)
	const vertInView   = (rect.top <= (windowHeight - offset)) && ((rect.top + rect.height) >= offset)

	return ( vertInView )

}


const api = {
	init: init
};

export default api;